import React, { PropsWithChildren } from "react";

import { Label } from "../inputs/Label";

type FormFieldProps = PropsWithChildren<{
  label?: string;
  className?: string;
}>;

/** @deprecated, just use {@link Label} */
const FormField = (props: FormFieldProps) => {
  return (
    <Label label={props.label ?? ""} className={props.className}>
      {props.children}
    </Label>
  );
};

export default FormField;
